import { render, staticRenderFns } from "./TrendData.vue?vue&type=template&id=0c36d0f1&"
import script from "./TrendData.vue?vue&type=script&lang=js&"
export * from "./TrendData.vue?vue&type=script&lang=js&"
import style0 from "./TrendData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports